import { IconX } from "@tabler/icons-react";
import React, { useEffect, useState } from "react";
import { useCountryUpdateMutation } from "../../../apis/locationApis";
import toast from "react-hot-toast";

type Props = {
  open: boolean;
  onClose: () => void;
  country: Country;
  fetchData: () => void;
};

interface Country {
  id?: string;
  name?: string;
  currencyCode: string;
  countryCode: string;
  dialCode: number;
  countryName?: string;
}

const CountryEditViewModal = ({ open, onClose, country, fetchData }: Props) => {
  const [editMode, setEditMode] = useState(false);
  const [data, setData] = useState<Country>({
    countryName: "",
    countryCode: "",
    currencyCode: "",
    dialCode: 0,
  });

  useEffect(() => {
    if (country) {
      setData({
        countryName: country.name,
        countryCode: country.countryCode,
        currencyCode: country.currencyCode,
        dialCode: country.dialCode,
      });
    }
  }, [country]);

  const { mutate, isPending } = useCountryUpdateMutation();


  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  const toggleMode = () => {
    if (!editMode) {
      setEditMode(!editMode);
      return;
    }

    mutate(
      { ...data, type: 'lmClient', id: country?.id },
      {
        onSuccess: (data) => {
          onClose()
          fetchData();
        },
        onError: (error) => {
          toast.error(`${error}`);
        },
      }
    );
    
  };

  if (!open) return null;

  return (
    <div className="fixed top-0 left-0 w-full h-screen bg-black/60 z-50 flex items-center justify-center">
      <div className="bg-[#F7F6F2] rounded-2xl w-[655px]">
        <div className="flex items-center justify-between px-4 py-4 border-b border-[#d2d2d2]">
          <h1 className="text-2xl">
            {editMode ? "Edit Country" : "View Country"}
          </h1>
          <button
            onClick={() => {
              if (editMode) setEditMode(false);
              else onClose();
            }}
            className="bg-[#F2F2F7] rounded-full p-1 cursor-pointer"
          >
            <IconX size={20} />
          </button>
        </div>

        <div className="w-full p-4 divide-y divide-[#D2D2D2]">
          {Object.entries(data).map(([key, value]) => (
            <div
              key={key}
              className="flex justify-between items-center w-full p-1.5"
            >
              <div className="w-full">
                <label className="capitalize text-[#212121] text-sm font-medium">
                  {key.replace(/([A-Z])/g, " $1")}
                </label>
              </div>
              <div className="w-full">
                {editMode ? (
                  <input
                    name={key}
                    value={value}
                    onChange={handleChange}
                    className="px-4 py-2 text-sm w-full rounded-full outline-none bg-white border border-[#D8D8D8]"
                  />
                ) : (
                  <div className="text-[#1E293B]">{value}</div>
                )}
              </div>
            </div>
          ))}
        </div>

        <div className="border-t border-[#D8D8D8] px-4 py-4 flex justify-end space-x-2">
          <button
            className="border border-[#D8D8D8] bg-transparent flex items-center rounded-full p-2 px-4 space-x-1 cursor-pointer text-base font-medium"
            onClick={() => {
              if (editMode) setEditMode(false);
              else onClose();
            }}
          >
            Cancel
          </button>
          <button
            className="border border-[#FBD037] bg-[#FBD037] flex items-center rounded-full p-2 px-6 space-x-1 disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer text-sm font-medium"
            onClick={toggleMode}
            disabled={isPending}
          >
            {editMode ? "Update" : "Edit"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CountryEditViewModal;
